<template>
  <div class="notifications-feed">
    <NotificationCard
      v-for="(notification, index) in notifications"
      :key="index"
      :notification="notification"
      @link-click="handleLinkClick"
    />
  </div>
</template>

<script>
import NotificationCard from '@/components/Notifications/NotificationsPage/NotificationCard.vue';

export default {
  name: 'NotificationsFeed',
  components: {
    NotificationCard,
  },
  props: {
    notifications: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    handleLinkClick(link) {
      if (link && link !== '#') {
        this.$f7.views.main.router.navigate(link);
      }
    },
  },
};
</script>
